module.exports = __webpack_public_path__ + "static/media/xdcpzy.874f5a7b.png";